<div class="thresholds-container">
  <div class="thresholds-content">
    <span class="title">{{ "commission.new.volume_thresholds" | translate }}</span>
    <div class="desc-container">
      <img src="assets/icones/info.svg" alt="" />
      <div class="secondary-text">
        {{ "commission.new.volume_thresholds_desc" | translate }}
      </div>
    </div>
    <hr />
    <form [formGroup]="thresholdForm" class="thresholds-form">
      <div *ngIf="thresholds.controls.length" formArrayName="thresholds" class="thresholds-array" #thresholdsArray>
        <div *ngFor="let threshold of thresholds.controls; let i = index" [formGroupName]="i" class="thresholds-input">
          <div class="standard-input has-icon">
            <label for="min_order_value">{{ "commission.new.min_order_value" | translate }}</label>
            <div class="input-container">
              <input
                type="number"
                formControlName="min_order_value"
                [placeholder]="'eg. ' + (i === 0 ? 1000 : i * 10000 + 1).toLocaleString(undefined)"
                (input)="onInputRemoveLeadingZero($event, threshold, 'min_order_value')"
              />
              <span class="btn-icon" style="cursor: default">€</span>
            </div>

            <div
              class="error"
              *ngIf="
                threshold.get('min_order_value')?.invalid && (threshold.get('min_order_value')?.touched || threshold.get('min_order_value')?.dirty)
              "
            >
              <small *ngIf="threshold.get('min_order_value')?.hasError('required')">{{ "validation.required" | translate }}</small>
              <small *ngIf="threshold.get('min_order_value')?.hasError('min')">{{
                "validation.min" | translate : { min: threshold.get("min_order_value")?.getError("min").min }
              }}</small>
            </div>
            <!-- Group error -->
            <div
              class="error"
              *ngIf="threshold.hasError('rangeInvalid') && (threshold.get('min_order_value')?.touched || threshold.get('min_order_value')?.dirty)"
            >
              <small>
                {{ "validation.range_less" | translate : { field1: "Min", field2: "Max" } }}
              </small>
            </div>
          </div>
          <div class="standard-input has-icon">
            <label for="max_order_value">{{ "commission.new.max_order_value" | translate }}</label>
            <div class="input-container">
              <input
                type="number"
                formControlName="max_order_value"
                [placeholder]="'eg. ' + (i === 0 ? 10000 : i * 10000 + 10000).toLocaleString(undefined)"
                (input)="onInputRemoveLeadingZero($event, threshold, 'max_order_value')"
              />
              <span class="btn-icon" style="cursor: default">€</span>
            </div>
            <div
              class="error"
              *ngIf="
                threshold.get('max_order_value')?.invalid && (threshold.get('max_order_value')?.touched || threshold.get('max_order_value')?.dirty)
              "
            >
              <small *ngIf="threshold.get('max_order_value')?.hasError('required')">{{ "validation.required" | translate }}</small>
              <small *ngIf="threshold.get('max_order_value')?.hasError('min')">{{
                "validation.min" | translate : { min: threshold.get("max_order_value")?.getError("min").min }
              }}</small>
            </div>
            <!-- Group error -->
            <div
              class="error"
              *ngIf="threshold.hasError('rangeInvalid') && (threshold.get('max_order_value')?.touched || threshold.get('max_order_value')?.dirty)"
            >
              <small>
                {{ "validation.range_greater" | translate : { field1: "Max", field2: "Min" } }}
              </small>
            </div>
          </div>
          <div class="standard-input has-icon">
            <label for="new_commission">{{ "commission.new.new_commission" | translate }}</label>
            <div style="display: flex; align-items: center; gap: 10px">
              <div class="input-container">
                <input type="number" formControlName="new_commission" (input)="onInputRemoveLeadingZero($event, threshold, 'new_commission')" />
                <span class="btn-icon" style="cursor: default">
                  <app-svg-icon svgIcon="percentage-cc"></app-svg-icon>
                </span>
              </div>
              <button
                type="button"
                class="action-btn secondary-btn icon-btn"
                style="flex: none"
                style="border-color: #970000"
                (click)="removeThreshold(i)"
              >
                <span class="icon" style="color: #970000">
                  <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
                </span>
              </button>
            </div>
            <div
              class="error"
              *ngIf="threshold.get('new_commission')?.invalid && (threshold.get('new_commission')?.touched || threshold.get('new_commission')?.dirty)"
            >
              <small *ngIf="threshold.get('new_commission')?.hasError('required')">{{ "validation.required" | translate }}</small>
              <small *ngIf="threshold.get('new_commission')?.hasError('min')">{{ "validation.min" | translate : { min: 0 } }}</small>
              <small *ngIf="threshold.get('new_commission')?.hasError('max')">{{ "validation.max" | translate : { max: 100 } }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="add-threshold-action">
        <button class="action-btn clear-btn" style="color: #6449DB" (click)="addThreshold()">
          <span class="icon"><app-svg-icon svgIcon="plus-cc"></app-svg-icon></span>
          {{ "commission.actions.add_threshold" | translate }}
        </button>
      </div>
    </form>
  </div>
  <div class="actions">
    <button type="button" class="action-btn secondary-btn" (click)="previous()">
      <span class="icon">
        <img src="assets/icones/arrow-back-black.svg" alt="" />
      </span>
      {{ "agent.actions.back" | translate }}
    </button>
    <button type="button" class="action-btn primary-btn" (click)="next()">
      {{ "agent.actions.proceed" | translate }}
      <span class="icon">
        <img src="assets/icones/arrow-right.svg" alt="" />
      </span>
    </button>
  </div>
</div>
